// extracted by mini-css-extract-plugin
export default {"mainHolder":"customer_mainHolder__IqUIw","rowHolder":"customer_rowHolder__XBXfn"};